import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RegisterComponent } from '@kion/data-models';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UsersFacade } from '@kion/data-access/data-access-users';
import { CorrelationObserverService } from '@kion/ngrx-helper';
import { CmsConfig } from '../../config/cms.config';
import { ToastService } from '@kion/ui';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { AuthsFacade } from '@kion/data-access/data-access-auths';
import { SubSink } from 'subsink';
import { MsalService } from '@kion/core';

@Component({
  selector: 'kion-cms-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit, OnDestroy {

  @Input() component: RegisterComponent;

  form: FormGroup;
  account: any;

  idpToken: any;
  invitationToken: string;

  isCorrectValidationToken = false;

  private readonly subSink: SubSink;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private usersFacade: UsersFacade,
    private correlationObserver: CorrelationObserverService,
    private authService: AuthsFacade,
    private cmsConfig: CmsConfig,
    private toastMessageService: ToastService,
    private translationService: TranslateService,
    private cookieService: CookieService,
    private msalService: MsalService,
    formBuilder: FormBuilder
  ) {
    this.subSink = new SubSink();
    this.form = formBuilder.group({
      firstName: new FormControl(),
      lastName: new FormControl(),
      email: new FormControl()
    });
    this.invitationToken = this.route.snapshot.params.token;
  }

  ngOnInit(): void {
    this.account = this.msalService.getAccount()
    if (this.account) {
      this.form.get('firstName').patchValue(this.account.given_name);
      this.form.get('lastName').patchValue(this.account.family_name);
      this.form.get('email').patchValue(this.account.email || this.account.emails[0]);
      this.subSink.sink = this.correlationObserver.subscribeToAction(
        this.usersFacade.validateInvitationToken(this.account.email, this.invitationToken),
        () => {
          this.isCorrectValidationToken = true;
        },
        () => {
          this.isCorrectValidationToken = false;
          this.toastMessageService.show(
            {
              type: 'error',
              text: this.translationService.instant('auth.toast.registration.validationTokenError')
            }
          );
          //TODO: logout user from msal!
        }
      )
    }
    this.idpToken = this.msalService.getAccount();
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  signIn() {
    this.cookieService.set('_redirect', this.router.url.substring(1), 200, '/');
    this.cookieService.set('_register', 'true', 200, '/', null, true, "Strict");
    this.router.navigate(['auth']).then(() => { });
  }

  performRegistration() {
    this.subSink.sink = this.correlationObserver.subscribeToAction(
      this.usersFacade.registerUser(
        this.msalService.getRawIdToken(),
        this.msalService.getRawIdToken(),
        this.form.get('firstName').value,
        this.form.get('lastName').value,
        this.form.get('email').value,
        this.account.tfp || this.account.acr,
        this.account.oid || this.account.sub,
        this.invitationToken
      ),
      () => {
        this.subSink.sink = this.correlationObserver.subscribeToAction(
          this.authService.userAuth(
            this.form.get('email').value,
            this.msalService.getRawIdToken(),
            this.msalService.getRawIdToken(),
            this.account.tfp || this.account.acr,
            this.account.oid || this.account.sub,
          ),
          () => {
            this.router.navigate(['device-list']).then(() => { });
          },
          () => { }
        );
      },
      () => {
        this.toastMessageService.show(
          {
            text: this.translationService.instant('auth.toast.registration.accountError'),
            type: 'error'
          }
        );
      }
    )
  }
}
